<template>
    <div class="flex">
        <iframe 
        style="width: 100vw; height: 90vh;"
        src="https://docs.google.com/presentation/d/e/2PACX-1vRoRbIeynbngvV5ipx4KB-I20CHRYGcyV1vL2C-aOddTdYLrx8Y4w8HNPB6k4FuH4fy3dFm_kXuCPKq/embed?start=false&loop=false&delayms=3000">
        </iframe>
    </div>
</template>

<script>

export default {
  data() {
    return {
     
    };
  },
  components: {
    // KTCodePreview
  },
  mounted() {
  }
};
</script>
